import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { IExpensesFilters, IExpenseCategory } from 'core/hooks';

import * as S from '../FakturowniaInvoices/FakturowniaInvoices.styled';

interface IExpensesFilterBarProps {
  filters: IExpensesFilters;
  onChange: (next: IExpensesFilters) => void;
  onReset: () => void;
  categories: IExpenseCategory[];
}

const SOURCE_OPTIONS = [
  { value: '', i18n: 'sourceAll' },
  { value: 'fakturownia', i18n: 'sourceFakturownia' },
  { value: 'manual', i18n: 'sourceManual' },
] as const;

/** Filter ribbon for the Expenses register (TZ §3.5). */
export const ExpensesFilterBar = memo(
  ({ filters, onChange, onReset, categories }: IExpensesFilterBarProps) => {
    const { t } = useTranslation();

    return (
      <S.FilterBar>
        <S.FilterGroup>
          <S.FilterLabel>
            {t('pages.fakturownia.expenses.filters.source')}
          </S.FilterLabel>
          <S.NativeSelect
            value={filters.source || ''}
            onChange={(e) =>
              onChange({ ...filters, source: e.target.value || undefined })
            }
          >
            {SOURCE_OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>
                {t(`pages.fakturownia.expenses.filters.${o.i18n}`)}
              </option>
            ))}
          </S.NativeSelect>
        </S.FilterGroup>

        <S.FilterGroup>
          <S.FilterLabel>
            {t('pages.fakturownia.expenses.filters.category')}
          </S.FilterLabel>
          <S.NativeSelect
            value={filters.categorySlug || ''}
            onChange={(e) =>
              onChange({
                ...filters,
                categorySlug: e.target.value || undefined,
              })
            }
          >
            <option value="">
              {t('pages.fakturownia.expenses.filters.categoryAll')}
            </option>
            {categories.map((c) => (
              <option key={c.id} value={c.slug}>
                {c.name}
              </option>
            ))}
          </S.NativeSelect>
        </S.FilterGroup>

        <S.ResetButton type="button" onClick={onReset}>
          {t('pages.fakturownia.expenses.filters.reset')}
        </S.ResetButton>
      </S.FilterBar>
    );
  },
);
